import { render, staticRenderFns } from "./FichasFiltroMMA.vue?vue&type=template&id=c2b5b730&"
import script from "./FichasFiltroMMA.vue?vue&type=script&lang=js&"
export * from "./FichasFiltroMMA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports